module.exports = __webpack_public_path__ + "static/media/ig-icon--white.6d4c1778.svg";